import { MODULE_LISTING_CONSTANT } from "../../../Helpers/constant";
import { Fetcher } from "../../../Helpers/fetcher";
import { ensureArray } from "../../../Helpers/utils";
export const MultiSelectModules = new Set([
    "Manage CLI",
    "Manage API CLI",
    "Manage Groups",
    "Manage Locations",
    "Manage Dialers"
]);


export const moduleOrder = [
    "Manage Dialers",
    "Manage CLI",
    "Manage API CLI",
    "Manage Groups",
    "Manage Users",
    "Voice Plans",
    "TTS Plans",
    "Voice Library",
    "Manage Campaign",
    "Manage Api Key",
    "Manage Locations"
];

export const sortModules = (a, b) => {
    const aIndex = moduleOrder.indexOf(a.mname);
    const bIndex = moduleOrder.indexOf(b.mname);

    return (
        (aIndex === -1 ? 999 : aIndex) -
        (bIndex === -1 ? 999 : bIndex)
    );
};

const manageCliKey = MODULE_LISTING_CONSTANT.MANAGE_CLI;

export const hasAnyPermissionSelected = (moduleList, permissions) => {
    return moduleList.some(m => {
        const p = permissions[m.mname] || {};

        const parentSelected =
            p.read || p.add || p.edit || p.delete || p.view_permission;

        const childSelected = m.children?.some(c => {
            const cp = permissions[c.moduleName] || {};
            return (
                cp.read ||
                cp.add ||
                cp.edit ||
                cp.delete ||
                cp.view_permission
            );
        });

        return parentSelected || childSelected;
    });
};

export const buildAclPayload = ({
    moduleList,
    permissions,
    aclName,
    userId,

}) => {
    const finalData = {};

    moduleList.forEach(m => {
        const hasChild = m.children?.length > 0;
        const p = permissions[m.mname] || {};

        if (!hasChild) {
            finalData[m.mname] = { ...p };
        } else {
            finalData[m.mname] = {
                read: p.read || false,
                view_permission: p.view_permission || false,
                children: m.children.map(c => ({
                    [c.moduleName]: permissions[c.moduleName] || {}
                }))
            };
        }
    });

    return {
        moduleOperation: JSON.stringify(finalData),
        aclName,
        userId,
    };
};

export const buildExpandedModulesFromPermissions = (permissions = {}) => {
    const expanded = {};

    Object.entries(permissions).forEach(([moduleName, moduleValue]) => {
        const children = moduleValue?.children || [];

        if (!Array.isArray(children) || children.length === 0) return;

        const shouldExpand = children.some(childObj => {
            const [childName, childPermissions] = Object.entries(childObj)[0] || [];

            if (!childPermissions) return false;

            return Object.values(childPermissions).some(v => v === true);
        });

        if (shouldExpand) {
            expanded[moduleName] = true;
        }
    });

    return expanded;
};

export const hasRequiredModuleSelections = (moduleListingData, permissions, multiSelectModules) => {
    return Array.from(multiSelectModules || []).every(moduleName => {
        const isActive = permissions?.[moduleName]?.view_permission;

        if (!isActive) return true;
        if (moduleName === manageCliKey) return true
        const selected = moduleListingData?.[moduleName];

        return Array.isArray(selected) && selected.length > 0;
    });
};

export const parseAclModuleListingData = (data = {}) => {
    try {
        const parsed =
            typeof data === "string"
                ? JSON.parse(data)
                : data || {};

        const restored = {};

        Object.entries(parsed).forEach(([moduleName, value]) => {
            if (!value) return;

            // CASE 1: already array format (your current structure)
            if (Array.isArray(value)) {
                restored[moduleName] = value;
            }

            // CASE 2: old structure with selectedItems
            else if (value?.selectedItems) {
                restored[moduleName] = value.selectedItems;
            }

            // CASE 3: fallback (if backend sends weird format)
            else if (Array.isArray(value?.data)) {
                restored[moduleName] = value.data;
            }
        });

        return restored;

    } catch (err) {
        console.log("parseAclModuleListingData error:", err);
        return {};
    }
};

export const buildModuleListingPayload = (moduleListingData = {}) => {
    const cleanedModuleListingData = Object.fromEntries(
        Object.entries(moduleListingData).map(([key, values]) => [
            key,
            values.map(v => v?.id ?? v)
        ])
    );

    return cleanedModuleListingData;
};